import React, { useState } from 'react';
import { ShowStatusButton } from './ShowStatusButton';

function RegistrationStatusForm() {
    const [documento, setDocumento] = useState('');
    const [showFaqModal, setShowFaqModal] = useState(false);

    const handleDocumentoChange = (event) => {
        setDocumento(event.target.value);
    };

    const openFaqModal = () => {
        setShowFaqModal(true);
    };

    const closeFaqModal = () => {
        setShowFaqModal(false);
    };

    return (
        <div className="h-full mt-24 mb-24 flex items-center justify-center w-full dark:bg-gray-950" data-testid="registration-status-form">
            <div className="bg-white shadow-md rounded-lg px-8 py-6 max-w-md" data-testid="registration-status-container">
                <h1 className="text-3xl font-bold text-center mb-4 dark:text-amber-500" data-testid="registration-status-title">PARQUEO</h1>
                
                <div className="mb-4" data-testid="registration-status-field">
                    <label htmlFor="email" className="block text-s font-medium text-start text-black dark:white mb-2" data-testid="registration-status-label">Introduce tu documento de identidad</label>
                    <input 
                        type="number" 
                        id="document_input" 
                        value={documento} 
                        onChange={handleDocumentoChange} 
                        className="shadow-sm rounded-md w-full px-3 py-2 border border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 invalid:border-pink-600 invalid:border-2" 
                        placeholder="1020304050" 
                        required 
                        data-testid="registration-status-input"
                    />
                </div>                 
                <div className="flex items-center justify-between mb-4" data-testid="registration-status-links">
                    <button
                        onClick={openFaqModal}
                        className="text-s text-amber-600 hover:text-amber-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amber-500 transition-colors"
                        data-testid="registration-status-inquiries-link"
                    >
                        ¿Inquietudes?
                    </button>
                    <a href="../"
                        className="text-s text-amber-600 hover:text-amber-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amber-500 transition-colors"
                        data-testid="registration-status-back-link"
                    >
                        Volver
                    </a>
                </div>
                <ShowStatusButton documento={documento} data-testid="registration-status-button" />                  
            </div>

            {/* Modal de FAQs */}
            {showFaqModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50" data-testid="faq-modal-backdrop">
                    <div 
                        className="bg-white rounded-xl shadow-xl max-w-md w-full max-h-[90vh] overflow-y-auto"
                        data-testid="faq-modal-container"
                    >
                        <div className="flex justify-between items-center border-b border-gray-200 p-6">
                            <h3 className="text-xl font-bold text-gray-800">Preguntas Frecuentes</h3>
                            <button 
                                onClick={closeFaqModal}
                                className="text-gray-400 hover:text-gray-600 focus:outline-none"
                                aria-label="Cerrar"
                                data-testid="faq-modal-close"
                            >
                                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>
                        
                        <div className="p-6 space-y-6">
                            <div className="space-y-4">
                                <div className="border-b border-gray-100 pb-4">
                                    <h4 className="font-semibold text-amber-600 mb-2">¿Cómo creo mi cuenta?</h4>
                                    <p className="text-gray-700">
                                        Para crear tu cuenta solo tienes que enviar una solicitud de registro a través del botón dispuesto para ello.
                                    </p>
                                </div>
                                
                                <div className="border-b border-gray-100 pb-4">
                                    <h4 className="font-semibold text-amber-600 mb-2">¿Cuánto tiempo tarda en aprobarse mi solicitud?</h4>
                                    <p className="text-gray-700">
                                        El tiempo de respuesta puede variar según la cantidad de solicitudes recibidas en el periodo de tiempo, el tiempo máximo de respuestas es 15 días.
                                    </p>
                                </div>
                                
                                <div className="border-b border-gray-100 pb-4">
                                    <h4 className="font-semibold text-amber-600 mb-2">¿Quién revisa mi solicitud?</h4>
                                    <p className="text-gray-700">
                                        Tu solicitud es revisada por los encargados del sitio, recibirás una respuesta en un tiempo máximo de 15 días hábiles.
                                    </p>
                                </div>
                            </div>
                            
                            <div className="mt-6 text-center bg-amber-50 p-4 rounded-lg">
                                <p className="text-sm text-gray-700 mb-2">
                                    Cualquier inquietud o duda adicional:
                                </p>
                                <a 
                                    href="mailto:jonhathansojo1@gmail.com" 
                                    className="text-amber-600 font-medium hover:text-amber-500 transition-colors"
                                >
                                    jonhathansojo1@gmail.com
                                </a>
                            </div>
                        </div>
                        
                        <div className="border-t border-gray-200 p-4 flex justify-end">
                            <button
                                onClick={closeFaqModal}
                                className="px-4 py-2 bg-gradient-to-r from-amber-500 to-amber-600 text-white rounded-lg shadow hover:from-amber-600 hover:to-amber-700 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:ring-offset-2 transition-all"
                                data-testid="faq-modal-close-button"
                            >
                                Cerrar
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
export { RegistrationStatusForm }

